import React from "react";
import { Box, Typography } from "@mui/material";
import ResponsiveAppBar from "../../components/ResponsiveAppBar";

const AiPlayground = () => {
  return (
    <Box sx={{ p: 3, textAlign: "center" }}>

      <Box
        component="iframe"
        src={process.env.REACT_APP_CHAINLIT_URL}
        width="100%"
        height="600px"
        sx={{
          border: "none",
          borderRadius: "8px",
        }}
      />
    </Box>

  );
};

export default AiPlayground;
